// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MerX","col":"styles_col__1gLpg","actions":"styles_actions__3Seg9","conflict":"styles_conflict__2BVzi"};